import router from '../../../router'
import NavigationBar from '../../../components/navigation-bar/NavigationBar'
import TabBar from '../../../components/tab-bar/TabBar'
import InputButton from '../../../components/input-button/InputButton'
import InputText from '../../../components/input-text/InputText'
import Loader from '../../../components/loader/Loader'
import { SortedTable, SortLink } from 'vue-sorted-table'
import { ScreenLoader } from '../../../utils/loading.util'
import { LocationService, Location } from '../../../services/location.service'

export default {
    name: 'Locations',
    components: {
        NavigationBar,
        TabBar,
        InputButton,
        InputText,
        SortedTable,
        SortLink,
        Loader
    },

    data() {
        return {
            searchValue: '',
            locations: [],
            sortedLocations: [],
            screenLoader: new ScreenLoader()
        }
    },

    mounted() {
        this.getLocations()
    },

    methods: {
        doAdd() {
            router.push(`/settings/locations/new`)
        },

        selectRow(rowId) {
            router.push(`/settings/locations/${rowId}`)
        },

        search() {
            this.sortedLocations = this.locations.filter(location => {
                const foundName = this.propertyContainsValue(location.name)
                const foundGroup = this.propertyContainsValue(location.getGroups())
                
                return foundName || foundGroup
            })
        },

        propertyContainsValue(value) {
            return value ? value.toLowerCase().includes(this.searchValue.toLowerCase()) : false
        },

        clearSearch() {
            this.searchValue = ''
            this.sortedLocations = this.locations
        },

        getLocations: async function() {
            this.screenLoader.start()

            try {
                const locations = await LocationService.getLocations()
                this.handleLocationsResponse(locations)
            }catch(error) {
                this.screenLoader.stopWithError(error)
            }
        },

        handleLocationsResponse(locations) {
            this.locations = locations.map(o => new Location(o))
            this.sortedLocations = this.locations
            this.screenLoader.stop()
        }
    }
}